// Simulates network latency for mock services. Swap callers to the real API
// client when the backend is ready — the async signatures stay identical.
export function delay<T>(value: T, ms = 450): Promise<T> {
  return new Promise((resolve) => setTimeout(() => resolve(value), ms));
}

export function maybeFail(probability = 0): boolean {
  return Math.random() < probability;
}
